import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalPaper: {
    margin: 'auto',
    width: '72%',
    padding: '1px 35px 35px 35px',
    marginTop: '5vh',
    outline: 'none',
    overflowX: 'auto',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.default
  },
  contentTitlesHeader: {
    marginTop: 45
  },
  entitiesContainerWrapper: {
    padding: 24,
    border: '1px solid #c4c4c4',
    borderRadius: 12,
    margin: '20px 0px'
  },
  entitiesContainer: {
    maxHeight: 250,
    overflowY: 'auto'
  },
  entitiesTableHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 0.15fr',
    alignItems: 'center',
    color: 'grey',
    marginBottom: 4,
    position: 'sticky',
    top: 0,
    padding: '10px 0px',
    backgroundColor: '#f7f7f7'
  },
  entitiesTableContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 0.15fr',
    alignItems: 'center',
    color: 'grey',
    marginBottom: 4,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: 52,
    transition: 'background-color 0.3s ease-in-out',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 3fr 1fr'
    }
  },
  contentInfoContainerWrapper: {
    padding: 24,
    border: '1px solid #c4c4c4',
    borderRadius: 12,
    marginTop: 20
  },
  contentInfoContainer: {
    maxHeight: 350,
    overflowY: 'auto'
  },
  contentInfoContainerWithChangedFields: {
    maxHeight: 150
  }
}))

export default useStyles
